import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/new_chatbot_widget.vue'

export default class extends Controller {

  static values = { organizationId: String, clientId: String, ownApiKey: Boolean }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('location mgmt widget controller connected.')

    const props = {
      organizationId: this.organizationIdValue,
      clientId: this.clientIdValue,
      ownApiKey: this.ownApiKeyValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
